import { documentationActions } from '../../actions/constant';

const { DASHBOARD_SIGNATURE_TEMPLATE, DASHBOARD_DOC_PREVIEW, RESET_GET_SIGNATURE_TEMPLATE } =
  documentationActions;

const intitialstate: object = {
  response: null,
  isGetSignatureTemplate: false,
  loader: false,
  getDashboardDoc: null,
  previewDashboardDoc: null,
};

export const getSignatureTemplateReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case DASHBOARD_SIGNATURE_TEMPLATE:
      return {
        ...state,
        getDashboardDoc: action.payload,
      };

    case DASHBOARD_DOC_PREVIEW:
      return {
        ...state,
        previewDashboardDoc: action.payload,
      };

    case RESET_GET_SIGNATURE_TEMPLATE:
      return intitialstate;

    default:
      return state;
  }
};
